import { useQuery } from '@tanstack/react-query';

import Api from '@/services/api';
import { QUERY_KEYS } from '@/utils/query-keys';
import type { AxiosErrorResponse, BaseReportsPaginated, BaseReportsPaginatedResponse, PaginatedData } from '@/types';

export type ListAllRebaDTO = BaseReportsPaginated;

export type ListAllRebaResponse = PaginatedData<BaseReportsPaginatedResponse>;

async function listRebaPaginated(params: ListAllRebaDTO): Promise<ListAllRebaResponse> {
	const url = '/ergonomic-tool/reba/reports/list-all';
	const { data } = await Api.get<ListAllRebaResponse>(url, {
		params
	});
	return data;
}

export const useListRebaPaginated = ({
	limit,
	offset,
	sector_id,
	company_id,
	cellule_id,
	report_name,
	activity_id,
	evaluator_id,
	original_name,
	created_at_end,
	workstation_id,
	organization_id,
	created_at_start,
	isSelectedReport
}: ListAllRebaDTO) => {
	const enabled = !!limit && !!isSelectedReport && offset >= 0;
	const rebaReport = useQuery<ListAllRebaResponse, AxiosErrorResponse>(
		[
			QUERY_KEYS.GET_REBA_REPORTS_PAGINATED,
			[
				limit,
				offset,
				sector_id,
				company_id,
				cellule_id,
				report_name,
				activity_id,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			]
		],
		() =>
			listRebaPaginated({
				limit,
				offset,
				sector_id,
				company_id,
				cellule_id,
				report_name,
				activity_id,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			}),
		{
			enabled,
			retry: 0
		}
	);
	return rebaReport;
};
